import { useMutation } from '@tanstack/react-query'

import { generateCustomVariants } from '../api'

const useGenerateCustomVariantsMutation = () => {
  return useMutation(generateCustomVariants)
}

export default useGenerateCustomVariantsMutation
